// Module store, so any code can raise feedback without a provider and tests need no wrapper.
const DEFAULT_DURATION_MS = { success: 3500, info: 3500, error: 6000 };
const MAX_VISIBLE = 3;

let toasts = [];
let nextId = 1;
const listeners = new Set();
const timers = new Map();

const emit = () => listeners.forEach((listener) => listener(toasts));

export const subscribeToasts = (listener) => {
    listeners.add(listener);
    listener(toasts);
    return () => listeners.delete(listener);
};

export const dismissToast = (id) => {
    window.clearTimeout(timers.get(id));
    timers.delete(id);
    toasts = toasts.filter((item) => item.id !== id);
    emit();
};

const push = (type, message, { duration, action } = {}) => {
    const id = nextId++;
    const dropped = toasts.slice(0, Math.max(0, toasts.length - MAX_VISIBLE + 1));
    dropped.forEach((item) => {
        window.clearTimeout(timers.get(item.id));
        timers.delete(item.id);
    });
    toasts = [...toasts.slice(dropped.length), { id, type, message, action }];
    timers.set(id, window.setTimeout(() => dismissToast(id), duration ?? DEFAULT_DURATION_MS[type]));
    emit();
    return id;
};

export const toast = {
    success: (message, options) => push('success', message, options),
    error: (message, options) => push('error', message, options),
    info: (message, options) => push('info', message, options),
};

export const clearToasts = () => {
    timers.forEach((timer) => window.clearTimeout(timer));
    timers.clear();
    toasts = [];
    emit();
};
